
import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppComponent } from '../app.component';
import { bmxurl, getAccess } from 'src/globals';
import { NavigationEnd, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { users_returndata } from 'src/types/user_returndata';
import { GlobalService } from '../_services/global.service';
import { membership_returndata } from 'src/types/membership_returndata';
import { emailtemplate_returndata } from 'src/types/emailtemplate_returndata';

@Component({
  selector: 'app-schedeuledsessionlist',
  templateUrl: './schedeuledsessionlist.component.html',
  styleUrls: ['./schedeuledsessionlist.component.css']
})
export class SchedeuledsessionlistComponent  implements OnInit {
  @ViewChild('classTable') classTable: Table;

  ListMemberships: any;
  DisplayMemberships: any;
  bmxurl: string;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  httpResponse: any;
  DisabledMembership: any;
  checked: boolean = true;
  isDisabled: boolean = true;
  showExpiredOnly: boolean = false;
  selectedItems: any[] = [];

  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;
  ListMembershipTypes: any[]
  SessionTypeOptions: any[] = [];
  selectedSessionTypeId: string = null;

  showCancelWarning: boolean = false;
  ChosenMembership: any;

  membershipbookings: any;

  EmailTemplates: any[] = [];
  selectedEmailTemplate: any;
  showEmailDialog: boolean = false;

  ExportColumns: any[] = [
    { field: 'customer.fullName', header: 'Name' },
    { field: 'sessiontypename', header: 'Session Type' },
    { field: 'salesid', header: 'Session ID' },
    { field: 'expirydatedisplay', header: 'Expiry Date' }
  ];

  constructor(
    private http: HttpClient, private appComp: AppComponent, private router: Router, private messageService: MessageService, private globalService: GlobalService) {

    }

  getMembershipType(membershiptypeid: string)
  {
    let membershiptype = this.ListMembershipTypes.find(m => m.membershiptypeid == membershiptypeid);

    if(membershiptype != null)
    {
      return membershiptype.name;
    }
    else
    {
      return "";
    }
  }

  ngOnInit(): void {

    this.globalService.setSmallScreenMenu(false);

    localStorage.removeItem("screenMemoryBookingss");
    localStorage.removeItem("screenMemoryEvents");
    
    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        if(getAccess("CLASSES", user)){

          this.AccessAllowed = true;
          this.loadgrid(false);
          this.loadEmailTemplates();
        }

        this.CompletedLoading = true;

      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });

  }

  loadEmailTemplates(){
    this.http.get(bmxurl + "EmailTemplateList/" + this.VenueID + "/false").subscribe(response => {
      this.httpResponse = response
      if(this.httpResponse.succeeded)
      {
        this.EmailTemplates = (response as emailtemplate_returndata).data;
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail: 'Error getting Email Templates, error: ' + error.messages});
    });
  }

  toggleDisabled(){
    this.loadgrid(!this.isDisabled);
  }

  applyExpiredFilter(){
    this.selectedItems = [];
    this.applyFilters();
  }

  onSessionTypeFilterChange(){
    this.selectedItems = [];
    this.applyFilters();
  }

  applyFilters(){
    if(!this.ListMemberships){
      this.DisplayMemberships = [];
      return;
    }

    let now = new Date();

    this.DisplayMemberships = this.ListMemberships.filter(m => {
      if(this.showExpiredOnly && !(new Date(m.enddate) < now)){
        return false;
      }

      if(this.selectedSessionTypeId && m.membershiptypeid != this.selectedSessionTypeId){
        return false;
      }

      return true;
    }).map(m => ({
      ...m,
      sessiontypename: this.getMembershipType(m.membershiptypeid),
      expirydatedisplay: this.formatExportDate(m.enddate)
    }));
  }

  formatExportDate(dateValue: string){
    if(!dateValue){
      return '';
    }

    let d = new Date(dateValue);
    let day = ('0' + d.getDate()).slice(-2);
    let month = ('0' + (d.getMonth() + 1)).slice(-2);
    let year = (d.getFullYear() % 100).toString().padStart(2, '0');
    return day + '/' + month + '/' + year;
  }

  exportSessions(){
    this.classTable.exportCSV();
  }

  openEmailDialog(){
    let canaccessemails = localStorage.getItem("BetaEmailing");
    if(canaccessemails != "true")
    {
      this.messageService.add({life: 7000, severity:'warn', summary:'Not Allowed', detail:"Our messaging system is in beta mode. You're invited to test it and provide feedback at support@smart-entertainment.co.uk. During the beta phase, this service is free. You can turn this on by going to settings and setting 'Event Beta Emailing' to 'Yes' in the Beta section"});
      return;
    }

    this.selectedEmailTemplate = null;
    this.showEmailDialog = true;
  }

  sendBulkEmail(){
    if(this.selectedEmailTemplate == null)
    {
      this.messageService.add({severity:'warn', summary:'Select a Template', detail:'Please choose an email template before sending.'});
      return;
    }

    if (!confirm("Are you sure you want to email the " + this.selectedItems.length + " selected member(s)?"))
    {
      return;
    }

    // NOTE: this endpoint does not exist yet — backend support for bulk-emailing
    // scheduled session members needs to be added before this ships.
    let payload = {
      venueid: this.VenueID,
      membershipids: this.selectedItems.map(item => item.membershipid),
      emailtemplateid: this.selectedEmailTemplate.emailtemplateid,
      emailsubject: this.selectedEmailTemplate.emailsubject
    };

    this.http.post(bmxurl + "sendtemplatescheduledsessionbulk", payload).subscribe(response => {
      this.httpResponse = response
      if(this.httpResponse.succeeded)
      {
        this.messageService.add({severity:'success', summary:'Email Sent', detail:'Email successfully sent to selected member(s)'});
        this.showEmailDialog = false;
        this.selectedItems = [];
      }
      else
      {
        this.messageService.add({severity:'error', summary:'Not Sent', detail: 'Error sending email, error: ' + this.httpResponse.messages[0]});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Sent', detail: 'An error occurred sending email to selected member(s)'});
    });
  }

  disableData(Membership)
  {
    this.ChosenMembership = Membership;

    this.showCancelWarning = true;
    // this.http.delete(bmxurl + "Membership/" + this.VenueID + "/" + MembershipID).subscribe(response => {
    //   this.httpResponse = response
    //   if(this.httpResponse.succeeded == true)
    //   {
    //     this.messageService.add({severity:'success', summary:'Disabled', detail:'Membership successfully disabled'});
    //     this.router.navigateByUrl("/membershiplist");

    //     this.loadgrid(false);
    //   }
    // }, error => {
    //   this.messageService.add({severity:'error', summary:'Not Disabled', detail: 'An error occurred disabling this Membership'});
    // })


  }


  cancelMembership(){
    this.showCancelWarning = false;

      this.http.delete(bmxurl + "Membership/" + this.VenueID + "/" + this.ChosenMembership.membershipid).subscribe(response => {
      this.httpResponse = response
      if(this.httpResponse.succeeded == true)
      {
        this.messageService.add({severity:'success', summary:'Disabled', detail:'Membership successfully cancelled'});
        this.router.navigateByUrl("/membershiplist");

        this.loadgrid(false);
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Disabled', detail: 'An error occurred cancelling this Membership'});
    })
  }
  
  loadgrid(showdisabled: boolean)
  {
      this.http.get(bmxurl + "membershiptypelist/" + this.VenueID + "/false").subscribe(response => {
        this.httpResponse = response
        if(this.httpResponse.succeeded)
        {
          this.ListMembershipTypes = (response as membership_returndata).data;

          //membershiptypelist returns memberships and scheduled sessions together, so the
          //filter has to be narrowed to the scheduled session types this screen lists.
          //ListMembershipTypes itself is left whole - it is used for name lookups and the
          //display order sort below.
          this.SessionTypeOptions = this.ListMembershipTypes
            .filter(mt => mt.membershiptype == "SCHEDULEDSESSION")
            .map(mt => ({ label: mt.name, value: mt.membershiptypeid }));

          if ((response as membership_returndata).messages.length > 0)
          {
            (response as membership_returndata).messages.forEach(error => {
              this.messageService.add({severity:'warn', summary:'Response Message', detail: error});
            });
          }

          this.http.get(bmxurl + "membershiplist/" + this.VenueID + "/" + showdisabled).subscribe(response => {
            this.httpResponse = response
            if(this.httpResponse.succeeded)
            {
              this.ListMemberships = (response as membership_returndata);

              this.ListMemberships = (response as membership_returndata).data.filter(m => m.membershiptype == "SCHEDULEDSESSION");

              this.ListMemberships.sort((a, b) => {
                let typeA = this.ListMembershipTypes.find(mt => mt.membershiptypeid == a.membershiptypeid);
                let typeB = this.ListMembershipTypes.find(mt => mt.membershiptypeid == b.membershiptypeid);
                return (typeA?.displayorder ?? 0) - (typeB?.displayorder ?? 0);
              });

              this.applyFilters();

              if ((response as membership_returndata).messages.length > 0)
              {
                (response as membership_returndata).messages.forEach(error => {
                  this.messageService.add({severity:'warn', summary:'Response Message', detail: error});
                });
              }
            }
            else
            {
              this.messageService.add({severity:'error', summary:'Not Saved', detail:'Error getting Memberships, error: ' + this.httpResponse.messages[0]});
            }
          }, error => {
            this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error getting Memberships, error: ' + error.messages});
          });
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Not Saved', detail:'Error getting Memberships, error: ' + this.httpResponse.messages[0]});
        }
      }, error => {
        this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error getting Memberships, error: ' + error.messages});
      });

  }

  editData(EditData)
  {
    let MembershipID = EditData;
    this.router.navigateByUrl("/customerscheduledsessionedit/" + MembershipID);
  }

  disableMulti()
  {
    this.selectedItems.forEach(element => {

    this.http.delete(bmxurl + "membership/" + this.VenueID + "/" + element.membershipid).subscribe(response => {
      this.httpResponse = response
      if(this.httpResponse.succeeded)
      {
        this.loadgrid(false);
      } 
      else{
        this.messageService.add({severity:'error', summary:'Not Saved', detail:'Error disabling Memberships, error: ' + this.httpResponse.messages[0]});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error disabling Memberships, error: ' + error.messages});
    })
    });
    
  }

  
  }
